import { render, staticRenderFns } from "./ad_users.vue?vue&type=template&id=6120b206&"
import script from "./ad_users.vue?vue&type=script&lang=js&"
export * from "./ad_users.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports